import React, { useEffect, useState } from 'react';
import { ErrorMessage } from 'formik';

const documentLabels = {
  businessCertificate: 'MSME/Udyam/Shop Act Certificate',
  gstCertificate: 'GST Certificate',
  adharCard: 'Aadhar Card',
  utilityBill: 'Any Address Proof Document',
};

const DocumentsUpload = ({ values, setFieldValue }) => {
  const [fileCountError, setFileCountError] = useState('');

  useEffect(() => {
    const uploadedFiles = Object.keys(documentLabels).filter(
      (key) => values[key] instanceof File
    );
    if (uploadedFiles.length < 2) {
      setFileCountError('At least two documents are required.');
    } else {
      setFileCountError('');
    }
  }, [values]);

  return (
    <>
      {Object.entries(documentLabels).map(([fieldName, label]) => {
        const file = values[fieldName];

        return (
          <div className="mb-3" key={fieldName}>
            <label htmlFor={fieldName} className="d-block fw-bold">
              {label}
            </label>

            {file ? (
              <div
                style={{
                  position: 'relative',
                  display: 'inline-block',
                  maxWidth: '200px',
                  height: '150px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  overflow: 'hidden',
                  backgroundColor: '#f8f9fa',
                }}
              >
                <img
                  src={URL.createObjectURL(file)}
                  alt={label}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
                <button
                  type="button"
                  onClick={() => setFieldValue(fieldName, null)}
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    background: '#dc3545',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '0 0 0 5px',
                    padding: '2px 6px',
                    fontSize: '14px',
                    cursor: 'pointer',
                  }}
                >
                  ✕
                </button>
              </div>
            ) : (
              <input
                id={fieldName}
                name={fieldName}
                type="file"
                accept="image/*"
                className="form-control form-control-sm"
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    setFieldValue(fieldName, e.target.files[0]);
                  }
                }}
              />
            )}

            <ErrorMessage
              name={fieldName}
              component="div"
              className="text-danger small"
            />
          </div>
        );
      })}

      {fileCountError && (
        <div className="text-danger small mb-2">
          <strong>{fileCountError}</strong>
        </div>
      )}
    </>
  );
};

export default DocumentsUpload;
